import { twMerge } from "tailwind-merge";
import styles from "./NewTag.module.css";

export const NewTag = ({ className }: { className?: string }) => {
  return <div className={twMerge(styles.container, className)}>New</div>;
};
